<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5 p-2" style="transform: translateX(-19vw)">
      <div class="d-flex justify-content-between">

      <div class="text-right" style="margin: 2vw 0;">
        <h5 style="font-size: 1.3vw !important; margin-right: 2vw;">
          مدیریت مستندات فرآیندی / {{$route.params.title}}
        </h5>

      </div>
        <button style=" transform: translateY(2vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
      </div>
      <div class="d-flex justify-content-between p-5 flex-nowrap">
        <div class="card bg-white col-4">
          <div style="background-color: #3742FA;" class="card-header text-white"><h5 class="text-white"
                                                                                     style="font-size: 1.6vw !important;">
            نوع مدرک</h5></div>
          <center class="mt-3">
            <input v-model="search" type="text" class="form-control w-75" placeholder="جستجو بر اساس نوع مدرک...">
            <hr class="w-75 m-3">
          </center>

          <center>
            <div class="w-75" style="overflow-y: scroll; height: 18vw;">
              <div v-for="item in filteredItems" :key="item.value"
                   class="bg-white d-flex align-items-baseline justify-content-start flex-row bg-white" style="height: 2vw;">
                <img style=" width: 1.3vw;" src="/img/doc.png" alt="">
                <p style="margin-right: 2vw;">
                  <label>
                    <input type="checkbox" :value="item.value" v-model="selectedItems">
                    {{ item.label }}
                  </label>
                </p>
              </div>
            </div>
          </center>
        </div>



        <div style="margin-right: 1vw; margin-left: 1vw;" class="card bg-white col-4">
          <div style="background-color: #3742FA;" class="card-header text-white"><h5 class="text-white"
                                                                                     style="font-size: 1.6vw !important;">
            فرآیند    </h5></div>
          <center class="mt-3">
            <input v-model="search_process" type="text" class="form-control w-75" placeholder="جستجو بر اساس نوع فرآیند...">
            <hr class="w-75 m-3">
          </center>

          <center>
            <div class="w-75" style="overflow-y: scroll; height: 18vw;">
              <div v-for="item in filteredItems_process" :key="item.title"
                   class="bg-white d-flex align-items-baseline justify-content-start flex-row bg-white " style="height: 2vw;">
                <img style=" width: 1.3vw;" src="/img/doc.png" alt="">
                <p style="margin-right: 2vw;">
                  <label>
                    <input type="checkbox" :value="item.id" v-model="selected_process">
                    {{ item.title }}
                  </label>
                </p>
              </div>
            </div>
          </center>
        </div>

        <div class="card bg-white col-4">
          <div style="background-color: #3742FA;" class="card-header text-white"><h5 class="text-white"
                                                                                     style="font-size: 1.6vw !important;">
            واحد سازمانی  </h5></div>
          <center class="mt-3">
            <input v-model="search_organization" type="text" class="form-control w-75" placeholder="جستجو بر اساس نوع واحد سازمانی...">
            <hr class="w-75 m-3">
          </center>

          <center>
            <div class="w-75" style="overflow-y: scroll; height: 18vw;">
              <div v-for="(itemOrganization,index) in filteredItems_organization" :key="itemOrganization.name"
                   class="bg-white d-flex align-items-baseline justify-content-start flex-row bg-white  " style="height: 2vw;">
                <img style=" width: 1.3vw;" src="/img/doc.png" alt="">
                <p style="margin-right: 2vw;">
                  <label>
                    <input type="checkbox" :value="itemOrganization.id" v-model="selected_organization">
                    {{ itemOrganization.name }}
                  </label>
                </p>
              </div>
            </div>
          </center>
        </div>
      </div>
      <button @click.prevent="searchMethod" class="btn btn-submit-1 btn-info mb-5">جستجو</button>
      <center >
        <hr style="transform: translateY(-1.5vw)" v-show="is_search" class="w-75 mt-2">
        <center v-show="!searchItems.length && is_search" class="mt-4">
          موردی یافت نشد
        </center>
        <table v-show="searchItems.length" class="table table-striped mt-2" style="width: 70vw;" >
          <thead>
          <tr>
            <th style="width: 1vw;">ردیف</th>
            <th>نام مدرک</th>
            <th>کد مدرک</th>
            <th>نوع مدرک</th>
            <th>محل بایگانی</th>
            <th>مدت زمان بایگانی</th>
            <th>فایل    </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in searchItems">
            <td scope="row">{{index+1}}</td>
            <td>{{item['name']}}</td>
            <td>{{item['code']}}</td>
            <td>{{item['type']}}</td>
            <td>{{item['location']}}</td>
            <td>{{item['time']}}</td>
            <td>
              <center> <a
                  target="_blank"
                  :href="item['file']"
                  class="btn btn-primary btn-submit-1"
                  download>دانلود</a>

              </center>
            </td>


          </tr>

          </tbody>
        </table>
      </center>


    </div>


  </div>
</template>
<script>

import {defineComponent} from "vue";
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Documents from "@/components/process_documentation_management/Document.vue";
import process from "@/components/process_documentation_management/proccess.vue";
import Organization from "@/components/process_documentation_management/Organization.vue";
import router from "@/router";

export default defineComponent({
  components: {Documents, Sidebar, Splash, process, Organization},
  data() {
    return {
      allItem: [
        {label: "خط مشی", value: "خط مشی"},
        {label: "آیین نامه", value: "آیین نامه"},
        {label: "نظامنامه", value: "نظامنامه"},
        {label: "روش اجرایی", value: "روش اجرایی"},
        {label: "دستور العمل", value: "دستور العمل"},
        {label: "مدارک طرح ریزی", value: "مدارک طرح ریزی"},
        {label: "فرم ها", value: "فرم ها"},
        {label: "برون سازمانی", value: "برون سازمانی"}
      ],
      search: '',
      is_search: false,
      selectedItems: [],
      allItem_organization: [],
      search_organization: '',
      selected_organization: [],
      allItem_process: [],
      search_process: '',
      selected_process: [],
      searchItems: [],
      id_route: this.$route['params']['id'],

    }
  },
  methods: {
    searchMethod(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('type', this.selectedItems)
      formdata.append('organization_id', this.selected_organization)
      formdata.append('process_id', this.selected_process)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/process_documentation_management/search_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            this.searchItems.length=0
            if (response.items) {
              this.is_search=true
              response.items.documents.forEach((ele)=>{
                this.searchItems.push(ele)
              })
            }


          })
          .catch();
    },
    allItems_organization() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/process_documentation_management/Organization_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.allItem_organization.length = 0
              response.all.forEach((item) => {
                this.allItem_organization.push(item)
              })
            }


          })
          .catch();

    },
    allItems_process() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('search', this.search)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/process_documentation_management/process_by_id/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all) {
              this.allItem_process.length = 0
              response.all.forEach((item) => {
                this.allItem_process.push(item)
              })
            }


          })
          .catch();

    },
    checkIsMother(){
      if (!this.is_mother){
        router.push('/')
      }

    }
  },
  mounted() {
    this.allItems_organization()
    this.allItems_process()
    this.checkIsMother()
  },
  computed: {
    filteredItems() {
      const search = this.search.trim().toLowerCase();
      if (search === '') {
        return this.allItem;
      } else {
        return this.allItem.filter(item => item.label.toLowerCase().includes(search));
      }
    },
    filteredItems_organization() {
      const search = this.search_organization.trim().toLowerCase();
      if (search === '') {
        return this.allItem_organization;
      } else {
        return this.allItem_organization.filter(item => item.name.includes(search));
      }
    },
    filteredItems_process() {
      const search = this.search_process.trim().toLowerCase();
      if (search === '') {
        return this.allItem_process;
      } else {
        return this.allItem_process.filter(item => item.title.includes(search));
      }
    },
  }
})
</script>
<style scoped>

</style>